<template>
    <!-- Feature Section start -->
    <section id="feature" class="feature">
      <div class="feature-decor">
        <div class="feature-circle1"><img :src='"../assets/images/feature2-blue.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="feature-phone">
            <img :src='"../assets/images/222.png"' class="img-fluid" alt="">
          </div>
          <div class="offset-lg-4 col-lg-8">
            <div class="row">
              <div class="col-sm-12 mrgn-md-top">
                <h2 class="title">features of<span> tovo</span></h2>
              </div>
              <div class="col-12 col-md-6">
                <ul class="feature-style">
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/1.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>user friendly</h3>
                    </div>
                    <div>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/3.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>high performance</h3>
                    </div>
                    <div>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/5.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>unlimited features</h3>
                    </div>
                    <div>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6 sm-m-top">
                <ul class="feature-style">
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/2.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>quick update</h3>
                    </div>
                    <div>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/4.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>100% secure</h3>
                    </div>
                    <div>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-icon">
                      <img :src='"../assets/images/icon/6.png"' alt="icon">
                    </div>
                    <div class="feature-subtitle">
                      <h3>24 x 7 support</h3>
                    </div>
                    <div>
                      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Section End -->
</template>
<script>
export default {
  name: 'feature'
}
</script>



// WEBPACK FOOTER //
// src/components/feature.vue